import * as types from "./mutation_types";
import axios from "axios";
import { URL_API } from "../../../../common/variables";

export const getItems = ({ commit }) => {
  commit(types.DR_TOGGLE_LOADING);
  axios
    .get(URL_API + "drs/")
    .then((response) => {
      commit(types.DR_TOGGLE_LOADING);
      commit(types.DR_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.DR_TOGGLE_LOADING);
      commit(types.DR_SET_ERROR, e.message);
    });
};

export const getAllItems = ({ commit }) => {
  commit(types.DR_ALL_TOGGLE_LOADING);
  axios
    .get(URL_API + "drs/all/")
    .then((response) => {
      commit(types.DR_ALL_TOGGLE_LOADING);
      commit(types.DR_ALL_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.DR_ALL_TOGGLE_LOADING);
      commit(types.DR_ALL_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.DR_RESET);
};
